/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Lucia Gotthardova, December 2020
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@staffino/primitive-controls';

type Props = {
  logoSrc?: string;
  label?: string;
  layoutDirection?: 'direction-row' | 'direction-column';
  reverseOrder?: boolean;
  width?: number;
};

const StaffinoBrand = ({
  logoSrc,
  label,
  layoutDirection = 'direction-row',
  reverseOrder = false,
  width = 80,
}: Props) => {
  const { t } = useTranslation();
  const defaultLogoSrc = '/public/images/staffino-logo.svg';
  const defaultLabel = t('Independent feedback system');
  return (
    <div className={`staffino-brand ${layoutDirection}`}>
      <Box className="staffino-label" order={reverseOrder ? 2 : 1} pb="4px">
        {label || defaultLabel}
      </Box>
      <Box order={reverseOrder ? 1 : 2}>
        <img
          src={logoSrc || defaultLogoSrc}
          alt="Staffino Logo"
          width={width}
          className="staffino-logo"
        />
      </Box>
    </div>
  );
};

export default StaffinoBrand;
